///<reference path='../../../mobile/core/directives/AutocompleterField.ts'/>
'use strict';
/*
    Creates an airport multi select field.
    Selectable options are exposed as `ac.data`.
*/
namespace Autocompleter {

    class AirportMultiSelect extends AutocompleterField {

        private available: any[] = [];
        private selected: any[] = [];
        private selectAttrFn: (item: any) => void;
        prefilled: string;
        notActive: boolean;
        _placeholder: string;

        constructor (
            public $scope: any,
            public $route: ng.route.IRouteService,
            public resourceService: any,
            public $q: ng.IQService,
            public autocompleter: any
        ) {
            super();
            this.areaOverride = this.areaOverride || 'flights';
            this.$scope.$watch('ac.currentValue', v => {
                this._resetSelected(_.flattenDeep([v]));
            });

            // Wrap `select` attribute fn
            this.selectAttrFn = this.select;
            this.select = (item) => {
                this.selectItem(item);
                this.selectAttrFn({items: this.selected});
            };

            if(this.prefilled != null) {
                this.prefill(this.prefilled);
            }
        }

        private prefill(data) {
            let prefill = data.split(/\s*,\s*/);
            this.prefix = data;
            this.fetch().then(() => {
                prefill.forEach(code => {
                    this.available.forEach(item => {
                        if(item.Code === code) {
                            this.select(item);
                        }
                    });
                });
            });
        }

        set placeholder(placeholder) {
            if(!this.notActive) {
                this._placeholder = placeholder;
            } else {
                this._placeholder = TRPCONFIG.Domain.DefaultStaticAirportLabel;
            }
        }

        get placeholder() {
            return this._placeholder;
        }

        update (result: any): void {
            // Called by super.fetch() with autocompleter.lookup result
            this.available = result.data;
            this._refreshData();

            if (_.isEmpty(this.data) && !this.notActive) {
                this.data = null;
                this.$scope.$emit('flash:error', this.resourceService.get('NOMATCHES'));
            }
        }

        selectItem (item: any): void {
            if (item && item.Code) {
                // Remove codes that are already selected
                let codes = _.reject(item.Code.split(','), (item1: any) => {
                    return _.find(this.selected, (item2: any) => item1 === item2.Code);
                });
                this._selectEachCode(codes, item.Title);
                this.prefix = '';
            }
        }

        removeItem (item: any): void {
            if (!item) { return; }
            this.selected.splice(this.selected.indexOf(item), 1);

            if (!this.selected.length) {
                this.deselect();
            }
            else {
                this.selectAttrFn({items: this.selected});
            }
        }

        private _refreshData (): void {
            this.data = this.addHeader(this._getAvailable(), 'AIRPORTS');
        }

        private _selectEachCode (codes: string[], sharedTitle: string) {
            codes.forEach(code => {
                if(!this.notActive || code === this.prefilled){
                    this.selected.push({Code: code, Title: sharedTitle});
                }
            });
        }

        private _resetSelected (items: any[] = []) {
        // Overwrites `this.selected` with data from `currentValue` attr on every change
            this.selected = [];
            items.forEach(item => {
                if (item && item.Code) {
                    this._selectEachCode(item.Code.split(','), item.Title);
                }
            });
            this._refreshData();
        }

        private _getAvailable () : any[]  {
            // Filters out items where all codes are already selected
            return _.reject(this.available, (item: any) => {
                let selectedCodes = _.map(this.selected, 'Code');
                if (item.Code.indexOf(',') > -1) {
                    return _.every(item.Code.split(','), (i) => {
                        return _.indexOf(selectedCodes, i) > -1;
                    });
                } else {
                    return _.indexOf(selectedCodes, item.Code) > -1;
                }
             });
        }

        // This was refactored from holidaySearchUnit.directive.js `getTitle()` but removed as not needed.
        // To reinstate, call from `removeItem()` logic when only one entry is left in `this.selected`

        // private _refreshLastAirport (item): ng.IPromise<any> {
        //     let airportCode = item.Code;
        //     return this.autocompleter.lookup('flights', airportCode).then(result => {
        //         if (this.selected[0]) {
        //             let match = _.find(this.available, {Code: airportCode}),
        //                 title = match && match.Title;
        //             if (title) {
        //                 this.selected[0].Title = title;
        //             }
        //         }
        //     });
        // }
    }

    angular
        .module('TR')
        .directive('airportMultiSelect', (): ng.IDirective => {
            return {
                restrict: 'E',
                replace: true,
                scope: {},
                controllerAs: 'ac',
                bindToController: {
                    placeholder: '@',
                    select: '&',
                    deselect: '&',
                    currentValue: '=',
                    focusTracker: '=',
                    minPrefix: '@',
                    notActive: '@',
                    prefilled: '@',
                    disabled: '@',
                    areaOverride: '@'
                },
                templateUrl: 'partials/home/directivetemplate?type=AirportMultiSelect',
                controller: AirportMultiSelect,
                transclude: true,
                link: (
                    scope: any,
                    el: JQuery
                ) => {
                    scope.ac.inputField = el.find('input');
                }
            };
        });
}
